const single_source_values = {
  id: "",
  type: "",
  physicalLink: "",
  name: "",
  safety: "",
  storePickup: false,
  location: [
    {
      key: "country",
      type: "string",
      value: "",
    },
    {
      key: "state",
      type: "string",
      value: "",
    },
    {
      key: "city",
      type: "string",
      value: "",
    },
    {
      key: "address",
      type: "string",
      value: "",
    },
  ],
  custom: [
    {
      key: "",
      type: "string",
      value: "",
    },
  ],
  enabled: false,
  contact: { name: "", phone: "" },
  ranking: "",
  aliases: "",
}

const source_values = {
  ...single_source_values,
  volumeCapacity: [
    {
      daysOfWeek: [],
      capacity: "",
      overCapacity: "",
    },
  ],
  dispatchCapacity: [
    {
      daysOfWeek: [],
      productType: "",
      capacity: "",
      deliveryType: "",
      overCapacity: "",
    },
  ],
  schedule: [
    {
      deliveryType: "",
      shippingType: [],
      disabled: false,
      coverageRadius: "",
      has_enable_time: false,
      enableTime: {
        from: "",
        to: "",
      },
      productType: "",
      leadtime: {
        unit: "",
        value: "",
      },
      deliverySlots: [
        {
          from: "",
          to: "",
          label: "",
          capacity: "",
          status: true,
          dayOfWeek: "",
        },
      ],
    },
  ],
  crossdock: [
    {
      productType: "",
      value: "",
      unit: "",
    },
  ],
  workingSessions: [
    {
      daysOfWeek: [],
      productType: "",
      capacity: "",
      from: "",
      to: "",
      enable_locktime: false,
      lockTime: {
        from: "",
        to: "",
      },
    },
  ],
  workingTime: [
    {
      daysOfWeek: [],
      from: "",
      to: "",
    },
  ],
  calendarSettings: {
    timezone: "",
    nonWorkingDays: [],
    nonWorkingDates: [],
  },
}

export const service_source_values = {
  ...single_source_values,
}

export default source_values
